import client from "./client";
import Apis from "./Path";
import clientFormData from "./clientFormData";
import { DOCUMENT_TYPE } from "../../constants";
import axios from "axios";
import store from "../../redux/store";

const create = async (data) => {
  return client.post(Apis.createTestPlan, data);
};

const update = async (id, data) => {
  return client.put(`${Apis.updateTestPlan}?id=${id}`, data);
};

const getTestSummaryByQuotationId = async (quotationId) => {
  return client.get(Apis.getTestSummary, { params: { quotationId } });
};

const getWordorPDF = async (data) => {
  return client.post(Apis.downloadPlan, data);
};

const getTestMaterialInfoByQuotationId = async (quotationId) => {
  return client.get(Apis.getTestMaterial, {
    params: { quotationId },
  });
};

const getTemplateFile = async () => {
  return client.get('/template-file/get-by-type', { params: {
      templateType: DOCUMENT_TYPE.TEST_PLAN
    }
  });
};

const uploadTemplateFile = async (file) => {
  return clientFormData.post('/template-file/upload-file', {
    file,
    templateType: DOCUMENT_TYPE.TEST_PLAN
  });
};

const downloadTemplateFile = async (filename = "test_plan_template") => {
  const downloadClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 30000,
    responseType: "arraybuffer",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Authorization: store.getState()?.auth.token?.accessToken || "",
    },
  });

  return downloadClient.get('/template-file/download-file', {
    params: { templateType: DOCUMENT_TYPE.TEST_PLAN }
  }).then((res) => {
    console.log(res)
    if (!res.data || res.data.length === 0 || !!res.headers.error) return res;
    var mimeType = "application/octet-stream";
    const name = `${filename}`;
    var blob = new Blob([res.data], {type: mimeType});

    var a = document.createElement("a");
    a.download = name;
    a.target = "_blank";

    if (window.navigator.msSaveBlob) {
      // for IE
      window.navigator.msSaveBlob(blob, name);
    } else if (window.URL && window.URL.createObjectURL) {
      // for Firefox
      a.href = window.URL.createObjectURL(blob);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } else if (window.webkitURL && window.webkitURL.createObject) {
      // for Chrome
      a.href = window.webkitURL.createObjectURL(blob);
      a.click();
    } else {
      // for Safari
      window.open(
        "data:" + mimeType + ";base64," + window.btoa(res.data),
        "_blank"
      );
    }
  });
};

const testPlanServices = {
  create,
  update,
  getTestSummaryByQuotationId,
  getWordorPDF,
  getTestMaterialInfoByQuotationId,
  getTemplateFile,
  uploadTemplateFile,
  downloadTemplateFile,
};

export default testPlanServices;
